import { createContext, useContext } from "react";
import type { ISelectContext as SelectContextType } from "./types";

const ISelectContext = createContext<SelectContextType | undefined>(undefined);

export const SelectProvider = ISelectContext.Provider;

export const useSelectContext = () => {
  const context = useContext(ISelectContext);
  if (!context) {
    throw new Error("useSelectContext must be used within a SelectProvider");
  }
  return context;
};
